// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b1bda3af","732":"32e4929e","977":"cb8f4633"}[chunkId] + ".chunk.js";
};